import {connect} from 'react-redux';
import React from 'react';
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify';

import Input from 'muicss/lib/react/input';
import Button from 'muicss/lib/react/button';
import {UserModel} from '/app/src/model';
import style from './style.css';

import {Flex} from '/app/src/component/'

class Login extends React.Component {
    constructor(props) {
        super(props);
        this._handleLoginClick = this._handleLoginClick.bind(this);
        this._handleInput = this._handleInput.bind(this);
        this._handleKeyPress = this._handleKeyPress.bind(this);
        // this._validateInput = this._validateInput.bind(this);
        this._handleForgottenClick = this._handleForgottenClick.bind(this);
        this._handleVerificationClick = this._handleVerificationClick.bind(this);
        this._handleResetVerificationMail = this._handleResetVerificationMail.bind(this);
        this._handleBackClick = this._handleBackClick.bind(this);
        this._renderLogin = this._renderLogin.bind(this);
        this._renderForgotten = this._renderForgotten.bind(this);
        this._renderVerifyEmail = this._renderVerifyEmail.bind(this);
        this._handleResetClick = this._handleResetClick.bind(this);
        this.failLogin = this.failLogin.bind(this);
        this._renderScreen = this._renderScreen.bind(this);

        this.state = {
            email: '',
            password: '',
            resetEmail: '',
            showForgottenInput: '',
            forgotPassword: false,
            verifyEmail: false,
            recoveryEmailExists: true,
            loginError: '',
            recoveryEmail: '',
            screen: 'login'
        }
    }

    failLogin(res) {
        if(res.body && res.body.error && res.body.error.message && res.body.error.message.indexOf('verified') > -1){
            this.setState({loginError: 'Användare har inte verifierat sitt konto'})
        }else{
            this.setState({loginError: 'Användarnamnet och/eller lösenordet stämmer inte'})
        }
    }

    _handleResetClick() {
        const recoveryEmail = this.state.recoveryEmail;
        UserModel.resetPassword(recoveryEmail)
            .end((err, res) => {
                if (res.status === 200) {
                    toast('Ett mail har skickats till angivet email')
                }
                if (res.status === 404) {
                    this.setState({recoveryEmailExists: false});
                }
            });
    }

    _handleResetVerificationMail() {
        const recoveryEmail = this.state.recoveryEmail;
        UserModel.resetVerificationMail(recoveryEmail)
            .end((err, res) => {
                if (res.status === 200) {
                    toast('Ett mail har skickats till angivet email')
                }
                if (res.status === 404) {
                    this.setState({recoveryEmailExists: false});
                }
            });
    }


    _handleForgottenClick() {
        this.setState((prevState) => ({screen: 'forgotten'}));
    }

    _handleVerificationClick(){
        this.setState((prevState) => ({screen: 'verifyEmail'}))
    }

    _handleBackClick(){
        this.setState((prevState) => ({screen: 'login'}))
    }

    _renderLogin() {
        return <Flex column grow center>
            <a href="https://jibber.se/">
                <Flex column hAlignContent='center'>
                    <img className={style.LoginImage} src='images/computing.png' alt='login'/>
                    <img className={style.LoginLogo} src='images/jibber-blue-logo.png' alt='login logo'/>
                </Flex>
            </a>
            <Input className={style.Epost} name='email' label='E-post' floatingLabel={true} value={this.state.email} onKeyPress={this._handleKeyPress} onChange={this._handleInput}/>
            <Input className={style.Password} name='password' label='Lösenord' floatingLabel={true} value={this.state.password} onKeyPress={this._handleKeyPress} onChange={this._handleInput} type='password'/>
            {this.state.loginError.length > 0 && <p className={style.errorMsg}> {this.state.loginError} </p>}
            <Button className={style.LoginButton} onClick={this._handleLoginClick}>Logga in</Button>
            <span className={style.ForgotPassword} onClick={this._handleForgottenClick}>
                Glömt lösenord?
            </span>
            <span className={style.ForgotPassword} onClick={this._handleVerificationClick}>
            Verifiera E-post
            </span>
        </Flex>
    }

    _renderForgotten() {
        return <Flex column center>
            <h1> Återställa lösenord </h1>
            <h4> Det är lugnt! Skriv in e-posten som kontot är registrerad under så skickar vi ett nytt lösenord. </h4>
            <Flex w='200px' column>
            <Input className={style.Epost}
                name='recoveryEmail'
                label='E-post'
                floatingLabel={true}
                value={this.state.recoveryEmail}
                onKeyPress={this._handleKeyPress}
                onChange={this._handleInput}/>
            <p className={style.errorMsg}> {!this.state.recoveryEmailExists && 'Angivet email finns inte i systemet.' } </p>
            </Flex>
            <Button className={style.LoginButton} onClick={this._handleResetClick}> Återställ lösenord </Button>
            <Flex mt='50vh'>
            <Button className={style.LoginButton} onClick={this._handleBackClick}> Tillbaka till login </Button>
            </Flex>
        </Flex>

    }

    _renderVerifyEmail() {
        return <Flex column center>
            <h1> Verifiera E-post </h1>
            <h4> Skriv in e-posten som du vill skicka verifikation till så skickar vi ett nytt email. </h4>
            <Flex w='200px' column>
            <Input className={style.Epost}
                name='recoveryEmail'
                label='E-post'
                floatingLabel={true}
                value={this.state.recoveryEmail}
                onKeyPress={this._handleKeyPress}
                onChange={this._handleInput}/>
            <p className={style.errorMsg}> {!this.state.recoveryEmailExists && 'Angivet email finns inte i systemet.' } </p>
            </Flex>
            <Button className={style.LoginButton} onClick={this._handleResetVerificationMail}> Verifiera E-post </Button>
            <Flex mt='50vh'>
            <Button className={style.LoginButton} onClick={this._handleBackClick}> Tillbaka till login </Button>
            </Flex>
        </Flex>
    }

    _handleLoginClick(){
        this.props.dispatch(UserModel.login(this.state.email, this.state.password, this.failLogin))
    }

    _handleInput(e){
        this.setState({[e.target.name]: e.target.value})
    }

    _handleKeyPress(e){
        if(e.key === 'Enter'){
            if (!this.state.forgotPassword)
                this._handleLoginClick();
        }
    }

    _renderScreen(){
        switch (this.state.screen) {
            case 'forgotten':
                return this._renderForgotten();
            case 'verifyEmail':
                return this._renderVerifyEmail();
            default:
                return this._renderLogin();
        }
    }

    render(){
        return (
            <Flex column grow>
                <Flex hAlignContent="right">
                    <a href="https://jibber.se/create-account">
                        <Button color="accent" className={style.LoginRegister}>
                            skapa konto
                        </Button>
                    </a>
                </Flex>
                {this._renderScreen()}
            </Flex>
        )
    }
}


export default withRouter(connect()(Login));



// WEBPACK FOOTER //
// src/layout/Login/index.js